var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99996 12.6255C6.81913 12.6255 6.64413 12.6022 6.49829 12.5497C4.26996 11.7855 0.729126 9.07302 0.729126 5.06552C0.729126 3.02385 2.37996 1.36719 4.40996 1.36719C5.39579 1.36719 6.31746 1.75219 6.99996 2.44052C7.68246 1.75219 8.60413 1.36719 9.58996 1.36719C11.62 1.36719 13.2708 3.02969 13.2708 5.06552C13.2708 9.07885 9.72996 11.7855 7.50163 12.5497C7.35579 12.6022 7.18079 12.6255 6.99996 12.6255ZM4.40996 2.24219C2.86413 2.24219 1.60413 3.50802 1.60413 5.06552C1.60413 9.04969 5.43663 11.2664 6.78413 11.7272C6.88913 11.7622 7.11663 11.7622 7.22163 11.7272C8.56329 11.2664 12.4016 9.05552 12.4016 5.06552C12.4016 3.50802 11.1416 2.24219 9.59579 2.24219C8.70913 2.24219 7.88663 2.65635 7.35579 3.37385C7.19246 3.59552 6.81913 3.59552 6.65579 3.37385C6.11329 2.65052 5.29663 2.24219 4.40996 2.24219Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.d0b34759624f65cd7e1a1329ddc72404.svg";
export { ForwardRef as ReactComponent };